import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchModalComponent } from './search-modal.component';
import { CardPageModule } from '../card/card.module';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		CardPageModule,
	],
	declarations: [SearchModalComponent],
	exports: [SearchModalComponent],
})
export class SearchModalModule {}
